import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getSignedMonetaryValue } from 'src/utils/typeFormaters';
import { sortInvoiceItems } from './invoiceItemOrder';
import React, { useState, Fragment } from 'react';
import { Icon, BasicTooltip, getBank } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import { Table, TableHead, TableBody, TableRow, TableCell, IconButton, Collapse, Button, Chip } from '@mui/material';
import useStyles from './styles';
export default function Row(_ref) {
  let invoice = _ref.invoice,
    addresses = _ref.addresses,
    isAppfolio = _ref.isAppfolio,
    _ref$isStripeApi = _ref.isStripeApi,
    isStripeApi = _ref$isStripeApi === void 0 ? false : _ref$isStripeApi,
    _ref$isUpcoming = _ref.isUpcoming,
    isUpcoming = _ref$isUpcoming === void 0 ? false : _ref$isUpcoming;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const products = isAppfolio ? ['AppFolio Unit Subscription Fee'] : ['Paper Invitation', 'Paper Statement', 'Unit Subscription Fee'];
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const getSpecs = status => {
    switch (status) {
      case 'Paid':
        return {
          label: t('subscriptions.paid'),
          variant: 'success'
        };
      case 'Failed':
        return {
          label: t('subscriptions.failed'),
          variant: 'critical'
        };
      case 'Upcoming':
        return {
          label: t('subscriptions.upcoming'),
          variant: 'info'
        };
      case 'Processing':
        return {
          label: t('subscriptions.processing'),
          variant: 'warning'
        };
      // A status this build has no case for still has to render. Falling through returned
      // undefined, and the dereference below took the whole tab down with it (LB-6126).
      default:
        return {
          label: String(status),
          variant: 'inactive'
        };
    }
  };
  const statusSpecs = invoice.status ? getSpecs(invoice.status) : null;
  const getItem = (item, product) => {
    var _item$product, _addresses$item$prope, _addresses$item$prope2, _addresses$item$prope3, _addresses$item$prope4, _addresses$item$prope5, _addresses$item$prope6, _item$product2, _item$product3, _item$product4;
    return ((_item$product = item[product]) === null || _item$product === void 0 ? void 0 : _item$product.quantity) !== null ? /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.addressCell
    }, item.firstNameLine === product || isAppfolio && product === 'AppFolio Unit Subscription Fee' ? "".concat((_addresses$item$prope = addresses[item.propertyId]) === null || _addresses$item$prope === void 0 ? void 0 : _addresses$item$prope.street, " ").concat((_addresses$item$prope2 = addresses[item.propertyId]) === null || _addresses$item$prope2 === void 0 ? void 0 : _addresses$item$prope2.city, ", ").concat((_addresses$item$prope3 = addresses[item.propertyId]) === null || _addresses$item$prope3 === void 0 ? void 0 : _addresses$item$prope3.state, " ").concat((_addresses$item$prope4 = addresses[item.propertyId]) === null || _addresses$item$prope4 === void 0 ? void 0 : _addresses$item$prope4.zip).concat((_addresses$item$prope5 = addresses[item.propertyId]) !== null && _addresses$item$prope5 !== void 0 && _addresses$item$prope5.secondary ? ', ' + ((_addresses$item$prope6 = addresses[item.propertyId]) === null || _addresses$item$prope6 === void 0 ? void 0 : _addresses$item$prope6.secondary) : '') : ''), /*#__PURE__*/React.createElement(TableCell, null, product), /*#__PURE__*/React.createElement(TableCell, null, (_item$product2 = item[product]) === null || _item$product2 === void 0 ? void 0 : _item$product2.quantity), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "$", (_item$product3 = item[product]) === null || _item$product3 === void 0 ? void 0 : _item$product3.unitPrice), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "$", (_item$product4 = item[product]) === null || _item$product4 === void 0 ? void 0 : _item$product4.amountPaid)) : null;
  };
  const getStripeApiItem = (item, showPropertyAddress) => {
    var _item$propertyAddress;
    return /*#__PURE__*/React.createElement(TableRow, {
      className: item.isDiscount ? classes.discountRow : undefined
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.addressCell
    }, showPropertyAddress ? (_item$propertyAddress = item.propertyAddress) !== null && _item$propertyAddress !== void 0 ? _item$propertyAddress : '' : '\u00A0'), /*#__PURE__*/React.createElement(TableCell, null, item.productName), /*#__PURE__*/React.createElement(TableCell, null, item.isDiscount ? '' : item.quantity), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, item.isDiscount ? '' : getSignedMonetaryValue(item.unitPrice)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, getSignedMonetaryValue(item.amountPaid)));
  };
  const getStripeApiSortedItems = () => {
    const sorted = sortInvoiceItems(invoice.invoiceItems);
    let lastAddressKey = null;
    return sorted.map((item, i) => {
      var _item$propertyAddress2, _item$productName;
      const key = (_item$propertyAddress2 = item.propertyAddress) !== null && _item$propertyAddress2 !== void 0 ? _item$propertyAddress2 : '';
      const showPropertyAddress = key !== lastAddressKey;
      if (showPropertyAddress) lastAddressKey = key;
      return /*#__PURE__*/React.createElement(Fragment, {
        key: "".concat(key, "-").concat((_item$productName = item.productName) !== null && _item$productName !== void 0 ? _item$productName : '', "-").concat(i)
      }, getStripeApiItem(item, showPropertyAddress));
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: () => setIsOpen(!isOpen),
    className: "".concat(classes.arrow, " ").concat(isOpen ? classes.arrowIsOpen : '')
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-down"
  }))), /*#__PURE__*/React.createElement(TableCell, null, invoice.periodName), /*#__PURE__*/React.createElement(TableCell, null, invoice.periodStart, " - ", invoice.periodEnd), !(isStripeApi && isUpcoming) && /*#__PURE__*/React.createElement(TableCell, null, invoice.invoiceNumber), /*#__PURE__*/React.createElement(TableCell, null, invoice.paymentMethodId === null ? null : /*#__PURE__*/React.createElement("span", {
    className: classes.cardWrapper
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    alt: "bank logo",
    height: "24",
    src: getBank(invoice.brand).logo,
    width: "40"
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.leftSpace
  }, invoice.last4 ? '•••• ' : '', invoice.last4)))), /*#__PURE__*/React.createElement(TableCell, null, statusSpecs ? /*#__PURE__*/React.createElement(Chip, {
    label: statusSpecs.label,
    variant: statusSpecs.variant
  }) : null), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, invoice.amountPaid), !(isStripeApi && isUpcoming) && /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, invoice.amountRefunded), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: t('subscriptions.preview_invoice'),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    disabled: !invoice.invoiceLink,
    onClick: () => window.open(invoice.invoiceLink),
    size: "small",
    variant: "actionIcon",
    'custom-attribute': '32-invoices-tab-table-row'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-search"
  })))))), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: 9,
    className: classes.collapseTable
  }, /*#__PURE__*/React.createElement(Collapse, {
    in: isOpen,
    className: isOpen ? classes.collapseIsOpen : ''
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.addressCell
  }, t('subscriptions.address')), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.product_name')), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.quantity')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('subscriptions.unit_price')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('subscriptions.amount')))), /*#__PURE__*/React.createElement(TableBody, null, !isStripeApi && invoice.invoiceItems.map((item, i) => /*#__PURE__*/React.createElement(Fragment, {
    key: i
  }, getItem(item, products[0]), !isAppfolio && getItem(item, products[1]), !isAppfolio && getItem(item, products[2]))), isStripeApi && getStripeApiSortedItems()))))));
}